import { ENV_VARS } from './env';
export const getEnvVar = (key, defaultValue) => {
    const envValue = ENV_VARS[key];
    return envValue ? envValue : defaultValue;
};
export const config = {
    apiBaseUrl: getEnvVar('VITE_API_BASE_URL', 'https://api-dev.thomsonreuters.com/digital-banking/minha-empresa-mobile'),
    apiEscritorioPersonAccess: getEnvVar('VITE_API_ESCRITORIO_PERSON_ACCESS', ''),
    apiZeztraBffUrl: getEnvVar('VITE_API_ZEZTRA_BFF_URL', 'https://api-dev.thomsonreuters.com/digital-banking/bank-integration-zeztra-bff'),
    apiDominioRewardsTerms: getEnvVar('VITE_API_DOMINIO_REWARDS_TERMS', 'https://assets.fintech.thomsonreuters.com/terms'),
    apiViaCepUrl: getEnvVar('VITE_API_VIA_CEP_URL', 'https://viacep.com.br'),
    apiIbkLegacyBffUrl: getEnvVar('VITE_API_IBK_LEGACY_BFF_URL', 'https://api-dev.thomsonreuters.com/digital-banking/internet-banking'),
    apiClientIbkUrl: getEnvVar('VITE_API_CLIENT_IBK_URL', 'https://api-dev.thomsonreuters.com/digital-banking/client-ibk'),
    apiAccountantIbkUrl: getEnvVar('VITE_API_ACCOUNTANT_IBK_URL', 'https://api-dev.thomsonreuters.com/digital-banking/accountant-ibk'),
    nodeEnv: getEnvVar('NODE_ENV', 'development'),
    featureFlagsCacheTtl: getEnvVar('VITE_FEATURE_FLAGS_CACHE_TTL', '300000'),
    featureFlagsDebugMode: getEnvVar('VITE_FEATURE_FLAGS_DEBUG_MODE', 'false'),
    datadogApplicationId: getEnvVar('VITE_DATADOG_APPLICATION_ID', ''),
    datadogClientToken: getEnvVar('VITE_DATADOG_CLIENT_TOKEN', ''),
    datadogEnv: getEnvVar('VITE_DATADOG_ENV', 'development'),
    datadogService: getEnvVar('VITE_DATADOG_SERVICE', 'ibk-frontend'),
    datadogSite: getEnvVar('VITE_DATADOG_SITE', 'datadoghq.com'),
    datadogAllowedTracingUrls: getEnvVar('VITE_DATADOG_ALLOWED_TRACING_URLS', ''),
};
export const isDevelopment = () => config.nodeEnv === 'development';
export const isProduction = () => config.nodeEnv === 'production';
export const isStaging = () => config.nodeEnv === 'staging';
